import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "../../hooks/use-query";
import RecipeForm from "../../components/recipe-form";

const FETCH_QUERY = `
  query($id: Int!) {
    recipes_by_pk(id: $id) {
      id
      recipeUrl
      imageUrl
      name
      instructions
      ingredients
    }
  }
`;

export default function({ match, history }) {
  let { data } = useQuery(FETCH_QUERY, { variables: { id: +match.params.id } });
  let recipe = data ? data.recipes_by_pk : null;

  function handleSave(recipe) {
    history.push(`/recipes/${recipe.id}`);
  }

  function handleDelete() {
    history.push("/");
  }

  return (
    <div className="bg-white -m-6 p-6">
      <div className="flex items-center">
        <div className="w-1/3">
          <Link
            to={`/recipes/${match.params.id}`}
            className="py-2 font-medium text-blue-500"
          >
            Cancel
          </Link>
        </div>
        <div className="w-1/3">
          <h1 className="text-center text-xl font-bold leading-none">Edit</h1>
        </div>
      </div>

      {recipe ? (
        <div className="mt-4">
          <RecipeForm
            recipe={recipe}
            didSave={handleSave}
            didDelete={handleDelete}
          />
        </div>
      ) : null}
    </div>
  );
}
